import { render, staticRenderFns } from "./ConexoesComponent.vue?vue&type=template&id=189f389c"
import script from "./ConexoesComponent.vue?vue&type=script&lang=js"
export * from "./ConexoesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports